import { FormControl } from "@/components/ui/form";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
} from "@/components/ui/select";
import { cn } from "@/lib/utils";
import { GENDER } from "@/types/common";
import { SelectValue } from "@radix-ui/react-select";
import { forwardRef } from "react";
import { ControllerRenderProps, useFormState } from "react-hook-form";
import { useTranslation } from "react-i18next";

interface GenderSelectProps extends ControllerRenderProps {
  placeholder?: string;
  disabled?: boolean;
}

export default forwardRef<HTMLButtonElement, GenderSelectProps>(
  function GenderSelect(
    { onChange, value, placeholder, disabled: disabledFromProps },
    ref,
  ) {
    const { t } = useTranslation();
    const { isSubmitting, disabled: formDisabled } = useFormState();

    return (
      <Select
        onValueChange={onChange}
        value={value}
        disabled={isSubmitting || disabledFromProps || formDisabled}
      >
        <FormControl>
          <SelectTrigger ref={ref} className={cn(!value && "text-slate-500")}>
            <SelectValue placeholder={placeholder} />
          </SelectTrigger>
        </FormControl>
        <SelectContent>
          {GENDER.map((genderOption) => (
            <SelectItem value={genderOption} key={genderOption}>
              {t(`gender.${genderOption}`)}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    );
  },
);
